import { makeStyles } from "@material-ui/core/styles";
import { lighten } from "polished";
import {
  grey300,
  primary,
  secondary,
} from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: theme.spacing(0.5),
    boxShadow: "1px 1px 10px rgba(151, 151, 151, 0.2)",
    padding: theme.spacing(1),
    color: ({ checked, image }) =>
      checked && !image ? lighten(0.475, secondary) : "",
    opacity: ({ disabled }) => (disabled ? 0.3 : 1),
  },
  mediaContainer: {
    "& svg": { width: 30, height: 30 },
    "& img": {
      width: "100%",
      height: "auto",
      opacity: ({ disabled }) => (disabled ? 0.5 : 1),
    },
    margin: theme.spacing(2),
    color: ({ checked }) => (checked ? primary : grey300),
  },
  radio: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: ({ checked }) => (checked ? primary : secondary),
    marginRight: theme.spacing(1),
  },
  radioText: {
    color: ({ checked }) => checked && primary,
  },
  radioContainer: {
    cursor: "pointer",
    pointerEvents: ({ disabled }) => (disabled ? "none" : "auto"),
  },
  actionLabel: {
    cursor: "pointer",
    color: secondary,
  },
  benefitName: {
    marginBottom: "28px",
    fontWeight: 700,
  },
  requireInformationText: {
    color: secondary,
  },
  image: {
    width: "100%",
    height: 118,
    backgroundImage: ({ cardImg }) => `url("${cardImg}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    opacity: ({ disabled }) => (disabled ? 0.5 : 1),
  },
}));

export default useStyles;
